var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-login"),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "loginScreen" },
        [
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row --mainRow" }, [
              _c("div", {
                staticClass:
                  "col-xs-12 col-md-4 col-lg-4 col-xl-6 d-none d-xl-block --loginBg leftCol"
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 col-md-12 col-lg-12 col-xl-6 paddingBox rightCol"
                },
                [
                  _c("h2", [_vm._v("Prihlásenie")]),
                  _vm._v(" "),
                  _vm.responseText != ""
                    ? _c(
                        "div",
                        {
                          class: "alert alert-" + _vm.responseType,
                          attrs: { role: "alert" }
                        },
                        [
                          _c("span", { class: "icon --" + _vm.responseType }),
                          _vm._v(
                            _vm._s(_vm.responseText) + "\n                    "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-lg-7 col-xl-7" }, [
                      _c("form", { on: { submit: _vm.formSubmit } }, [
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-12 col-md-12" }, [
                            _c("label", [_vm._v("E-mail")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.email,
                                  expression: "email"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "email", required: "" },
                              domProps: { value: _vm.email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.email = $event.target.value
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-12 col-md-12" }, [
                            _c("label", [
                              _vm._v(
                                "\n                                            Heslo\n                                            "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "float-right",
                                  attrs: { role: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$bvModal.show(
                                        "modalLostPassword"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                                Zabudli sme heslo\n                                            "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "password", required: "" },
                              domProps: { value: _vm.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(0)
                      ]),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn --primary w-100 --facebookNormal mb-5 mb-lg-0",
                          on: { click: _vm.fbLogin }
                        },
                        [
                          _vm._v(
                            "\n                                Prihlásiť sa cez Facebook "
                          ),
                          _c("span", {
                            staticClass: "icon d-none d-md-inline-block"
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(2)
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "modalLostPassword",
              staticClass: "modal fade",
              attrs: {
                id: "modalLostPassword",
                "hide-footer": "",
                "hide-header": "",
                centered: "",
                tabindex: "-1",
                role: "dialog",
                "aria-labelledby": "modalLostPasswordTitle",
                "aria-hidden": "true"
              }
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "m-modalInfo__close",
                  attrs: { block: "" },
                  on: {
                    click: function($event) {
                      return _vm.$bvModal.hide("modalLostPassword")
                    }
                  }
                },
                [_c("span", { staticClass: "icon" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body o-modalLostPassword" }, [
                _c("div", { staticClass: "m-modalLostPassword__content" }, [
                  _c(
                    "h2",
                    { staticClass: "m-modalLostPassword__name text-center" },
                    [_vm._v("Zabudli ste heslo?")]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v(
                      "Ak si zabudol svoje heslo, zadaj svoj email a nové heslo ti bude poslané do emailu"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "m-modalLostPassword__footer d-flex" },
                  [
                    _c(
                      "form",
                      {
                        staticClass: "w-100",
                        on: { submit: _vm.formSubmitResetPwd }
                      },
                      [
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-12 col-md-12" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.zabudnute_heslo_email,
                                  expression: "zabudnute_heslo_email"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "email",
                                placeholder: "Váš email"
                              },
                              domProps: { value: _vm.zabudnute_heslo_email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.zabudnute_heslo_email =
                                    $event.target.value
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row text-center mb-0" },
                          [
                            _c("div", { staticClass: "col-12 col-md-12" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn --primary",
                                  attrs: { type: "submit" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$bvModal.hide(
                                        "modalLostPassword"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Resetovať")]
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "col-12 col-md-12" }, [
        _c("button", { staticClass: "btn --primary w-100" }, [
          _vm._v("\n                                            Prihlásiť sa "),
          _c("span", { staticClass: "icon" })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-separator text-center" }, [
      _c("span", [_vm._v("alebo")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-5 col-xl-5" }, [
      _c("aside", { staticClass: "o-widget mb-md-5" }, [
        _c("div", { staticClass: "m-widgetContent" }, [
          _c("div", { staticClass: "m-widgetContent__description" }, [
            _c("p", [
              _vm._v(
                "Tu sa môže trieda prihlásiť, starať sa o svoju kravičku a súťažiť o super ceny."
              )
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v("Benefity:")])
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "m-widgetContent__list" }, [
            _c("li", [_vm._v("starostlivosť o kravičku prináša súťažné body")]),
            _vm._v(" "),
            _c("li", [_vm._v("celá trieda sa spoločne zapája")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("môžete spolu vyhrať aj cenu pre svoju školu/škôlku")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }